import { arrayOf, shape, string } from 'prop-types';
import React from 'react';
import SubsectionNav from 'components/SubsectionNav';
import styles from './styles';

function AmpSubsectionNav(props) {
  const { menuItems } = props;

  return (
    <div className="AmpRecipeRoundupNav">
      <SubsectionNav menuItems={menuItems} />
      <style jsx>{styles}</style>
    </div>
  );
}

AmpSubsectionNav.propTypes = {
  menuItems: arrayOf(
    shape({
      roundupId: string.isRequired,
      title: string.isRequired
    })
  ).isRequired
};

export default AmpSubsectionNav;
